<template>
  <div class="loading" v-if="show">
    <div class="loader"></div>
  </div>
</template>

<script>
  import loadingService from '@/services/loadingService';

  export default {
    data: () => ({
      show: false,
      counter: 0,
      delay: 300,
      lastShowTime: 0
    }),
    methods: {
      showLoading (show) {
        this.counter += show ? 1 : -1;
        if (show) {
          this.lastShowTime = Date.now();
          if (this.counter === 1) {
            setTimeout(() => { this.show = this.counter > 0; }, this.delay);
          }
        } else if (Date.now() < this.lastShowTime + this.delay) {
          if (this.counter === 0) {
            setTimeout(() => { this.show = this.counter > 0; }, this.delay);
          }
        } else {
          this.show = this.counter > 0;
        }
      }
    },
    created () {
      loadingService.onLoading(this.showLoading);
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/misc/LoadingSpinner.vue